import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ThumbnailService } from '../thumbnail.service';
let k=1,j=90
@Component({
  selector: 'app-manage-services',
  templateUrl: './manage-services.component.html',
  styleUrls: ['./manage-services.component.scss'],
})
export class ManageServicesComponent {

  loader:boolean = true;
  storeObj;
  search:any=[];
  filterLength;
  subsObj;
  pageEnd:boolean=false;
  change:boolean;
  constructor(public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    public santinzer:DomSanitizer,
    public thumb:ThumbnailService
   ) { }

   ionViewWillEnter(){
     this.getService();   
   }

   getService(){ 
    this.service.getAllItems().subscribe((res:any)=>{
      if(res){
        this.storeObj = res; 
        this.storeObj = this.storeObj.filter(res=>{return res.packageInd == false})
        this.storeObj.map(dat=>{
          if(dat.imageId){
            this.thumb.getThumbIcon(dat)
          }
        })
        this.loader = false; 
      }else{
        this.loader = false; 
        this.handler.res("No Data Found")
      }
   },err =>{
    this.loader = false;
    this.handler.res("No Data For You")
   })
  }
   
  deleteServices(id){
    this.loader=true;
    this.service.deleteService(id).subscribe(res=>{
      this.loader=false;
      this.handler.res("Deleted successfully")
    this.ionViewWillEnter();
    },
    err=>{
      this.handler.err(err)
      this.loader=false
    })
  }  
  
   editService(id){
     this.router.navigate(['edit-service/',+id])
   }

   getUsersList(event) {
    this.loader = true; 
  this.ionViewWillEnter();
  setTimeout(() => {
    event.target.complete();
  }, 1000);
 
  }

  
 ionViewWillLeave(){
  this.search = "";
  this.pageEnd=false;
  k=1;
 }
 clear(){
  this.search="";
}
ngDoCheck(): void {
  this.filterLength = sessionStorage.getItem('len')

}

 }
